import React, { Component } from 'react';
import ReactJWPlayer from 'react-jw-player';
import storage from 'shared/utils/storage';

const withWebPlayer = WrappedComponent => {
  return class WWP extends Component {
    playerId = 'web-player-div';
    licenseKey = 'CQbn1ELM3cK0IZE1wWQdw1dZnRoKhR+ozWcr88s9OlHnfZfC';
    playerScript = 'https://content.jwplatform.com/libraries/tZ78avDx.js';
    player = null;
    // isPlayer = false;

    repeatList = [
      {
        name: 'NONE',
        toast: '반복을 사용하지 않습니다.',
      },
      {
        name: 'ALL',
        toast: '전체 음악을 반복합니다.',
      },
      {
        name: 'SINGLE',
        toast: '현재 음악을 반복합니다',
      },
      {
        name: 'SCRIPT',
        toast: '현재 소절을 반복합니다.',
      },
    ];

    toastMsg = {
      muteOn: 'Mute ON',
      muteOff: 'Mute OFF',
      shuffleOn: 'Shuffle ON',
      shuffleOff: 'Shuffle OFF',
      userPlaylitAdd: '내 리스트에 추가하였습니다.',
      userPlaylitDel: '내 리스트에서 제거하였습니다.',
    };

    state = {
      isPlayer: false,
      disable: true,
    };

    purchase = null;

    componentDidMount() {
      this._playerChecker(this.props);
    }

    async componentWillReceiveProps(nextProps) {
      /**
        현재 위치에 있는 url과 이동하는 페이지 url이 다르면
        _playerChecker 리턴
        _playerChecker는 웹플레이어를 실행시킨 url과 이동한 url이 다른지
        체크하는 함수
      */
      if (this.props.location.pathname !== nextProps.location.pathname) {
        this._playerChecker(nextProps);
      }

      /**
       * 현재 webPlayer의 upc값이 다르고 길이가 12자리면
       * 새로운 upc값을 생성
       */
      if (
        this.props.webPlayer.upc !== nextProps.webPlayer.upc &&
        nextProps.webPlayer.upc.length === 12
      ) {
        this.getMediaKey(nextProps);
      }
    }

    /**
     * 특정 강의 upc미디어키 가져오기
     */
    getMediaKey = async props => {
      const selectedItem = props.webPlayer.playlist.find(
        item => props.webPlayer.upc === item.upc,
      );
      if (selectedItem) {
        console.log({ selectedItem });
        const data = {
          type: 'BACKGROUND',
          step: 'PLAY',
          mediaUrl: selectedItem.file,
        };
        await this.props.getMediaKeyRequest(data);
      }
    };

    initialState = () => {
      this.props.initialState();
    };

    // method
    linkToPlayer = async (upc, callback) => {
      // console.log(`linkToPlayer`);
      const { location } = this.props;
      const playlist = this.player.getPlaylist();

      this._initTimestamp({
        disable: true,
      });
      // console.log('linkToPlayer', { upc });
      const path = `/player/${upc}/play${location.search}`;
      if (typeof callback === 'function') await callback(upc);

      // console.log({ playlist, upc });
      const index = playlist.findIndex(item => item.upc === upc);
      if (index >= 0) this.player.playlistItem(index);
      this.props.history.push(path);

      if (this.player) {
        await this.player.seek(0);
      }
    };

    /**
     *  웹 컨트롤러 내 리스트에 추가하기
     */
    toggleMyList = async () => {
      console.log(`toggleMyList`);
      const { webPlayer } = this.props;
      const { upc, action } = webPlayer;
      const isUserPlaylist = action.getType === 'userPlayList' ? true : false;

      if (isUserPlaylist) {
        this.player.pause();
      }

      webPlayer.playItemOption.forEach(async item => {
        if (item.upc === upc) {
          let message = '';
          if (!item.userPlayListChoice) {
            // 내 리스트에 담기!
            message = this.toastMsg.userPlaylitAdd;

            await this.props.postUserPlaylistItemRequest(upc);
          } else {
            // 내 리스트에서 빼기!
            message = this.toastMsg.userPlaylitDel;

            if (action.getType === 'userPlayList') await this.actionNext();
            await this.props.deleteUserPlaylistItemRequest(
              upc,
              action,
              isUserPlaylist,
            );
            this.player.play();
          }
          this.props.pushToastApp({ message });
          // item.userPlayListChoice = !item.userPlayListChoice;
        }
      });
    };

    getPlayerState = () => {
      if (this.player) {
        const state = this.player.getState();
        return state;
      }
    };
    getPlaylist = () => {
      if (this.player) {
        const playlist = this.player.getPlaylist();
        return playlist;
      }
    };
    getPlaylistIndex = () => {
      if (this.player) {
        const playlistIndex = this.player.getPlaylistIndex();
        return playlistIndex;
      }
    };

    /**
     * 현재 재생곡 타임라인 bar
     */
    setTimeline = async percent => {
      // console.log(`setTimeline`);

      if (this.player) {
        let start = 0;
        let end = 0;
        const index = this.player.getPlaylistIndex();
        const playlist = this.player.getPlaylist();
        const item = playlist[index];
        if (item.start) start = item.start;
        if (item.end) end = item.end;

        const { webPlayer } = this.props;
        const { timestamp } = webPlayer;
        const { duration } = timestamp;
        let secound = 0;

        let endPoint = 0;
        if (end > 0) endPoint = duration - end;
        const length = duration - (start + endPoint);

        secound = (length / 100) * percent + start;
        // console.log({ percent, secound, length, endPoint });
        if (typeof this.player.seek === 'function') {
          const { repeat } = this.props.webPlayer;
          console.log({ repeat });
          if (this.repeatList[repeat].name === 'SCRIPT') {
            return this._findScript(secound);
          }
          this.player.seek(secound);
        }
        return;
      }
    };

    /**
     * 볼륨 설정
     * state값으로 변경
     */
    setVolume = async percent => {
      // console.log(`setVolume`);
      percent = percent > 100 ? 100 : percent > 0 ? percent : 0;
      await this.props.setState({
        volume: percent,
      });

      if (percent > 0) {
        const mute = false;
        await this.props.setState({ mute });
        storage.set('mute', mute);
        if (this.player) this.player.setMute(mute);
      }

      storage.set('volume', percent);
      if (this.player) this.player.setVolume(percent);
    };
    setSeek = timestamp => {
      // console.log(`setSeek`);
      const { repeat } = this.props.webPlayer;
      console.log({ repeat });
      if (this.repeatList[repeat].name === 'SCRIPT') {
        return this._findScript(timestamp);
      }
      // console.log({ playing });
      this.player.seek(timestamp);
    };
    setToggleMute = async () => {
      // // console.log(`toggleMute`);
      const { webPlayer } = this.props;
      const mute = !webPlayer.mute;
      await this.props.setState({ mute });
      storage.set('mute', !webPlayer.mute);
      if (this.player) this.player.setMute(!webPlayer.mute);
    };

    targetNext = upc => {
      // console.log(`targetNext`);

      this._initTimestamp({
        disable: true,
      });

      const playlist = this.player.getPlaylist();
      const item = playlist.findIndex(li => li.upc === upc);

      if (item >= 0) this.player.playlistItem(item);

      if (!this.props.webPlayer.playing) {
        this.actionPlay();
        this.player.seek(0);
      }
    };

    /**
     * 다음 곡 재생
     */
    actionNext = () => {
      console.log(`actionNext`);
      if (this.player) {
        const { webPlayer } = this.props;
        const { shuffle, shuffleList, repeat, playlist } = webPlayer;
        console.log({ repeat });

        this._initTimestamp({
          disable: true,
        });

        this._cancelRepeatScript();
        const currentIndex = this.player.getPlaylistIndex();

        if (shuffle) {
          const next = this.shuffleNext(shuffleList, currentIndex);

          /**
           * 마지막곡에서 다음곡을 눌렀을때
           */
          if (
            this.repeatList[repeat].name === 'NONE' &&
            next.isRepeat
            // next.index === shuffleList.length - 1
          ) {
            this.player.seek(0);
            this.player.stop();
            return;
          }

          this.player.playlistItem(next.item);
          this._playerUrlPusher(next.item);
          return next.item;
        }

        let index = currentIndex + 1;
        if (index >= playlist.length) {
          if (this.repeatList[repeat].name === 'NONE') {
            this.props.setState({ disable: false });
            this.player.seek(0);
            return;
          } else {
            index = 0;
          }
        }

        this.player.playlistItem(index);
        if (this.state.isPlayer) {
          this._playerUrlPusher(index);
        }

        return;
      }
    };

    /**
     * 이전 곡 재생
     */
    actionPrev = async () => {
      // console.log(`actionPrev`);
      if (this.player) {
        const { webPlayer } = this.props;
        const { shuffle, shuffleList, repeat } = webPlayer;
        console.log({ repeat });

        this._initTimestamp({
          disable: true,
        });

        this._cancelRepeatScript();
        const isPrev = true;
        const playlist = this.player.getPlaylist();
        let currentIndex = this.player.getPlaylistIndex();
        const position = this.player.getPosition();
        //5초 이하에서의 이전곡 클릭시 현재 곡의 seek을 0으로 맞춰줌
        if (position > 5) {
          await this._initTimestamp();

          await this.player.seek(0);
          this.player.playlistItem(currentIndex);

          return;
        }

        if (shuffle) {
          const next = this.shuffleNext(shuffleList, currentIndex, isPrev);
          this.player.playlistItem(next.item);

          if (
            this.repeatList[repeat].name === 'NONE' &&
            next.isRepeat
            // next.index === shuffleList.length - 1
          ) {
            this.player.seek(0);
            this.player.stop();

            this._playerUrlPusher(next.item);
            return;
          }

          this._playerUrlPusher(next.item);
          return next.item;
        }

        currentIndex--;
        if (currentIndex < 0) {
          if (this.repeatList[repeat].name !== 'NONE')
            currentIndex = playlist.length - 1;
          else currentIndex = 0;
        }
        const nextItem = this.player.getPlaylistItem(currentIndex);
        if (nextItem) {
          this.player.playlistItem(currentIndex);
          this._playerUrlPusher(currentIndex);

          return currentIndex;
        }
      }
    };

    // 곡 재생 시키기
    actionPlay = () => {
      // console.log(`actionPlay`);
      if (this.player) {
        if (!this.props.webPlayer.playing) this.player.play();
      }
    };

    actionStop = () => {
      // console.log(`actionStop`);
      if (this.player) {
        if (this.props.webPlayer.playing) this.player.stop();
      }
    };

    // 현재 곡 일시정지
    actionPause = () => {
      // console.log(`actionPause`);
      if (this.player) {
        this.player.pause();
      }
    };

    // 곡 반복설정
    actionRepeat = async () => {
      console.log(`actionRepeat`);
      const { webPlayer = {} } = this.props;
      console.log({ wRepeat: webPlayer.repeat });

      let repeat = webPlayer.repeat + 1;
      if (repeat === this.repeatList.length) {
        repeat = 0;
      }

      if (this.player && this.repeatList[repeat].name === 'SCRIPT') {
        await this._findScript();
      }
      // console.log({ repeat });
      storage.set('repeat', repeat);

      const message = this.repeatList[repeat]
        ? this.repeatList[repeat].toast
        : '';

      await this.props.setState({ repeat });
      if (message) this.props.pushToastApp({ message });
      if (this.player) {
        this.player.setConfig({ repeat });
      }
    };

    /**
     * 곡 랜덤재생
     */
    actionShuffle = async () => {
      // console.log(`actionShuffle`);
      const state = {};
      const { webPlayer } = this.props;
      state.shuffle = false;
      state.shuffleList = [];

      if (!webPlayer.shuffle) {
        state.shuffle = true;
        state.shuffleList = this._getShuffleList();
      }

      storage.set('shuffle', state.shuffle);
      storage.set('shuffleList', state.shuffleList);
      const message = state.shuffle
        ? this.toastMsg.shuffleOn
        : this.toastMsg.shuffleOff;
      this.props.pushToastApp({ message });

      this.props.setState(state);
    };

    /**
     * 랜덤 재생
     */
    shuffleNext = (shuffleList, currentIndex, isPrev = false) => {
      let isRepeat = false;
      const findShuffleIndex = shuffleList.findIndex(
        key => key - 1 === currentIndex,
      );

      //마지막곡에서 클릭시 0번째로
      let shuffleIndex = findShuffleIndex + (isPrev ? -1 : 1);
      if (shuffleIndex >= shuffleList.length) {
        // Next 에서만 발생
        shuffleIndex = 0;
        isRepeat = true;
      } else if (shuffleIndex < 0) {
        // Prev 에서만 발생
        shuffleIndex = shuffleList.length - 1;
        isRepeat = true;
      }
      const shuffleItem = shuffleList[shuffleIndex] - 1;
      return {
        item: shuffleItem,
        index: shuffleIndex,
        isRepeat,
      };
    };

    /**
     * timestap 초기화?
     * disable이 true일때는 player가 기능작동을 하지 않는다.
     */
    _initTimestamp = async (obj = {}) => {
      const { timestamp } = this.props.webPlayer;
      await this.props.setState({
        ...obj,
        timestamp: {
          ...timestamp,
          percent: 0,
          current: 0,
          duration: 0,
        },
      });
    };

    /**
     * 타임라인 bar 계산
     */
    _findScript = seekTime => {
      const { timestamp, script } = this.props.webPlayer;
      const currentTime = seekTime ? seekTime : timestamp.current;
      const mediaScript = script.mediaScript;
      const repeatItem = mediaScript.reduce((a, b) =>
        b.start <= currentTime ? b : a,
      );
      const repeatScript = mediaScript.findIndex(
        script => script.id === repeatItem.id,
      );
      this.props.setState({ repeatScript });
    };

    /**
     * 플레이어 체크 확인
     * 팝송 페이지에 있는지 확인
     */
    _playerChecker = nextProps => {
      let pathSplit = nextProps.location.pathname.split('/');
      const isPlayer =
        pathSplit[1] === 'player' && pathSplit[3] === 'play' ? true : false;

      this.setState({ isPlayer });
    };

    /**
     * 곡 변경시 url의 미디어 upc 값이 변경된다.
     */
    _playerUrlPusher = async key => {
      const { webPlayer, history, location } = this.props;

      if (this.state.isPlayer && typeof key === 'number') {
        const item = webPlayer.playlist[key];
        if (item && item.upc) {
          let path = `/player/${item.upc}/play${location.search}`;
          await history.push(path);
        }
      }
    };

    /**
     * 반복 취소하기
     * 소절반복일때는 storage repaet을 해제한다.
     */
    _cancelRepeatScript = () => {
      const { repeat } = this.props.webPlayer;
      console.log({ repeat });
      if (this.repeatList[repeat].name === 'SCRIPT') {
        storage.set('repeat', 0);
        this.props.setState({
          repeat: 0,
          repeatScript: null,
        });
      }
    };

    _resetShuffleList = () => {
      const state = {};
      state.shuffleList = this._getShuffleList();
      storage.set('shuffleList', state.shuffleList);
      this.props.setState(state);
    };

    /**
     * 곡 랜덤 만드는 함수
     */
    _getShuffleList = () => {
      if (this.player) {
        // console.log('getPlaylistIndex', this.player.getPlaylistIndex());
      }
      const playlist = this.player ? this.player.getPlaylist() : [];
      const currentIndex = this.player ? this.player.getPlaylistIndex() : 0;
      const shuffleList = this.player
        ? this._shuffleRandom(playlist.length, currentIndex)
        : [];

      return shuffleList;
    };

    /**
     * 랜덤 리스트 만들기
     */
    _shuffleRandom = (n, index = null) => {
      let ar = [];
      let temp;
      let rnum;
      for (let i = 1; i <= n; i++) {
        ar.push(i);
      }
      for (let i = 0; i < ar.length; i++) {
        rnum = Math.floor(Math.random() * n);
        temp = ar[i];
        ar[i] = ar[rnum];
        ar[rnum] = temp;
      }

      //현재곡을 가장 앞의 배열번호로 변경
      if (index !== null) {
        const current = ar.splice(ar.findIndex(a => a - 1 === index), 1);
        ar = current.concat(ar);
      }
      return ar;
    };

    render() {
      const { webPlayer } = this.props;

      // Player Method
      const handle = {
        initialState: this.initialState,

        getPlayerState: this.getPlayerState,
        getPlaylist: this.getPlaylist,
        getPlaylistIndex: this.getPlaylistIndex,

        setTimeline: this.setTimeline,
        setVolume: this.setVolume,
        setSeek: this.setSeek,
        setToggleMute: this.setToggleMute,

        targetNext: this.targetNext,

        actionNext: this.actionNext,
        actionPrev: this.actionPrev,
        actionPlay: this.actionPlay,
        actionStop: this.actionStop,
        actionPause: this.actionPause,
        actionRepeat: this.actionRepeat,
        actionShuffle: this.actionShuffle,

        linkToPlayer: this.linkToPlayer,
        toggleMyList: this.toggleMyList,
      };

      const jwplayer = {
        player: this.player,
        status: webPlayer,
        handle,
        repeatList: this.repeatList,
      };

      const path = this.props.location.pathname.split('/')[1];
      if (path === 'study') {
        return <WrappedComponent {...this.props} />;
      }

      return (
        <>
          <WrappedComponent {...this.props} jwplayer={jwplayer} />

          {webPlayer.playlist.length ? (
            <ReactJWPlayer
              licenseKey={this.licenseKey}
              playerScript={this.playerScript}
              playerId={this.playerId}
              // playlist={webPlayer.playlist.map(item => ({
              //   ...item,
              //   withCredentials: true,
              // }))}
              playlist={webPlayer.playlist}
              onReady={this.onReadyEventListener}
              onVideoLoad={this.onVideoLoadEventListener}
              isAutoPlay={webPlayer.autostart}
              onPlay={this.onPlayEventListener}
              onResume={this.onResumeEventListener}
              onPause={this.onPauseEventListener}
              onTime={this.onTimeEventListener}
              onError={this.onErrorEventListener}
              onMute={this.onMuteEventListener}
              onUnmute={this.onUnmuteEventListener}
            />
          ) : null}
        </>
      );
    }
    //* ErrorEvent */

    onMuteEventListener = e => {
      // console.log(`onMuteEventListener `, e);
      // const message = this.toastMsg.muteOn;
      // this.props.pushToastApp({ message });
    };
    onUnmuteEventListener = e => {
      // console.log(`onUnmuteEventListener `, e);
      // const message = this.toastMsg.muteOff;
      // this.props.pushToastApp({ message });
    };

    onErrorEventListener = async e => {
      console.log(`onErrorEventListener `, e);
      this.props.setState({ disable: false });
    };

    // Event listener
    onReadyEventListener = e => {
      // console.log(`onReadyEvent`, { isPlayer: this.state.isPlayer });
      const { webPlayer } = this.props;
      this.player = window.jwplayer(this.playerId);
      const playlist = this.player.getPlaylist();

      let autostart = false;
      if (this.state.isPlayer) {
        autostart = true;
      }

      // console.log({ autostart });
      this.player.setConfig({
        repeat: webPlayer.repeat,
        // autostart: webPlayer.autostart,
        autostart,
        mute: webPlayer.mute,
        volume: webPlayer.volume,
      });

      if (webPlayer.action.upc) {
        const actionIndex = webPlayer.playlist.findIndex(
          pl => pl.upc === webPlayer.action.upc,
        );

        if (actionIndex >= 0) {
          // this.player.playlistItem(actionIndex);
          // this.player.pause();
        } else {
          if (this.state.isPlayer) {
            this.props.history.push(
              `/player/${playlist[0].upc}/play${
                this.props.location.search ? this.props.location.search : ''
              }`,
            );
          } else {
            this.player.playlistItem(0);
          }
        }
      }

      this.player.on('beforePlay', this.onBeforePlayEventListener);
      this.player.on('complete', this.onCompleteEventListener);
      // console.log(`onReady - done`);
    };

    onBeforePlayEventListener = e => {
      console.log(`beforePlay`);

      const index = this.player.getPlaylistIndex();
      const item = this.player.getPlaylist()[index];

      if (item.purchase === false) {
        this.props.setState({
          playing: false,
          disable: true,
        });
        return this.player.stop();
      }
      this.props.setState({
        playing: true,
      });
    };

    onCompleteEventListener = async e => {
      // console.log(`complete`);
      this.player.stop();
      this.props.setState({ disable: true });
      const { webPlayer } = this.props;

      const currentIndex = await this.player.getPlaylistIndex();
      if (this.repeatList[webPlayer.repeat].name === 'SINGLE') {
        await this.player.stop();
        this.player.playlistItem(currentIndex);

        this.props.setState({ disable: false });
        return currentIndex;
      }
      // console.log(`onComplete - before actionNext`);

      return this.actionNext();
    };

    onVideoLoadEventListener = e => {
      console.log(`onVideoLoad`, e);
      const { webPlayer } = this.props;
      const { action } = webPlayer;

      this._cancelRepeatScript();
      this.props.getMediaScriptRequest(e.item.upc); //타임 구간마다 노래가사 담겨있는 api
      this.props.postUserMediaPlayRequest(e.item.upc);
      this.props.setState({
        title: e.item.titleEng,
        artist: e.item.artist,
        artistEng: e.item.artistEng,
        image: e.item.image,
        upc: e.item.upc,
        action: { ...action, upc: e.item.upc },
      });

      let onReady = false;
      this.player.on('bufferChange', e => {
        if (!onReady) {
          onReady = true;
          // this.player.pause();
          if (webPlayer.shuffle && !webPlayer.shuffleList.length) {
            this._resetShuffleList();
          }
          this.props.setState({ disable: false });
        }
      });
    };
    onPlayEventListener = e => {
      // console.log(`onPlay`);
      this.props.setState({ playing: true });
    };
    onPauseEventListener = e => {
      console.log(`onPause`);
      this.props.setState({ playing: false });
    };
    onResumeEventListener = e => {
      // console.log(`onResume`);
      this.props.setState({ playing: true });
    };
    onTimeEventListener = async e => {
      let interval = e.currentTime - this.props.webPlayer.timestamp.current;
      const { repeat, repeatScript, script, playlist } = this.props.webPlayer;
      if (
        this.repeatList[repeat].name === 'SCRIPT' &&
        typeof repeatScript === 'number' &&
        repeatScript >= 0 &&
        script.mediaScript &&
        script.mediaScript[repeatScript]
      ) {
        const repeatOne = this.props.webPlayer.script.mediaScript[
          this.props.webPlayer.repeatScript
        ];
        if (e.currentTime < repeatOne.start || e.currentTime > repeatOne.end) {
          return this.player.seek(repeatOne.start);
        }
      }

      if (interval < 0.5 && interval > -0.5) return;

      /** play 구간 정리 */

      let start = 0;
      let end = 0;

      const index = this.player.getPlaylistIndex();
      const item = playlist[index];

      if (item && item.start) start = item.start;
      if (item && item.end) end = item.end;

      if (start > 0 && e.currentTime < start) {
        this.player.seek(start);
        // return this.player.seek(start);
      }

      if (end && e.currentTime >= end) {
        // 한곡 반복시엔 Next 가 아닌 Seek 추가
        if (this.repeatList[this.props.webPlayer.repeat].name === 'SINGLE') {
          this.player.stop();
          this.player.playlistItem(index);

          this.props.setState({ disable: false });
          return index;
        }

        return this.actionNext();
      }

      const percent = this.currentTimeToPercent(
        e.currentTime,
        e.duration,
        start,
        end,
      );

      this.props.setState({
        timestamp: {
          current: e.currentTime,
          duration: e.duration,
          percent,
        },
      });
    };

    currentTimeToPercent = (current = 0, duration = 0, start = 0, end = 0) => {
      let endPoint = 0;
      if (end > 0) endPoint = duration - end;
      const length = duration - (start + endPoint);
      const point = current - start;
      let percent = (point / length) * 100;
      return percent;
    };
  };
};

export default withWebPlayer;
